import { includesValue } from '@/helpers/object.js'
import { THEMES, VARIANTS } from '@/components/_shared/Form/form-helper'

export default {
  value: {
    type: Boolean,
    required: true,
  },
  id: {
    type: String,
    default: '',
  },
  isRequired: {
    type: Boolean,
    default: true,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    required: true,
  },
  theme: {
    type: String,
    default: THEMES.default,
    validator(value) {
      return includesValue(THEMES, value)
    },
  },
  variant: {
    type: String,
    default: VARIANTS.default,
    validator(value) {
      return includesValue(VARIANTS, value)
    },
  },
}
